// Tipos e helpers da gestão de administradores da plataforma.

import type { PlatformRole } from './platformRoles'

/** GET /api/admin/platform-admins — linha da listagem. */
export interface PlatformAdminItem {
    id: string
    nome: string
    email: string
    activo: boolean
    /** true se é o próprio administrador autenticado (remover/desactivar ficam bloqueados). */
    proprio: boolean
    roles: PlatformRole[]
    criadoEm: string
}

export function formatDate(iso: string | null | undefined): string {
    if (!iso) return '—'
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return '—'
    return d.toLocaleDateString('pt-PT', { day: '2-digit', month: 'short', year: 'numeric' })
}
